<template>
  <el-row>
    <a class="download-button" style="float:right;cursor:pointer"
        @click="showTopicForm"
             >
             Add Topic<i class="el-icon-download"></i>
    </a>
    <div id="topicForm" style="display:none">
        <el-form ref="form"
                 :model="form"
                 label-position="top">
          <el-form-item label="Topic">
            <el-input v-model="form.topic"
                      :disabled="false"></el-input>
          </el-form-item>
          <el-form-item label="Description">
		              <el-input type="textarea"
                      :rows="5"
                      v-model="form.content"></el-input>
          </el-form-item>
          <font color="red">you need to check your answers here within 48 hours</font>
	  <br/>
	  <br/>
          <el-form-item>
            <el-button type="primary"
                       @click="addTopic()">Add</el-button>
          </el-form-item>
        </el-form>
    </div>


    <el-table :data="topicList"
              style="width: 100%">
      <el-table-column prop="topic.caseno"
                       label="Case No">
      </el-table-column>
      <el-table-column prop="topic.topic"
                       label="Topic">
      </el-table-column>
      <el-table-column prop="status"
                       label="Status">
      </el-table-column>
      <el-table-column prop="topic.create_date"
                       label="Date">
      </el-table-column>
      <el-table-column fixed="right"
                       header-align="center"
                       align="center"
                       label="Operations"
                       width="140">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click.native.prevent="showTopic(scope.row)">
            View</el-button>
          <el-button @click.native.prevent="deleteTopic(scope.row)"
                     type="danger"
                     size="small">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
export default {
  created() {
    this.getTopics();
         this.axios({
        method: 'get',
        url: `/user/loginid`,
      }).then(res => {

        if(res.data.loginid == 1){
          this.isAdmin = true;
        }
        else{
          this.isAdmin = false;
        }
      });


    //this.form = {topic: 'default topic'};
  },
  data() {
    return {
      headers: { Authorization: 'Bearer ' + localStorage.token },
      topicList: [],
      token: localStorage.token,
      form: {topic : ''},
      isAdmin : false,
    };
  },
  methods: {
    showTopicForm(){
      topicForm.style.display = 'block';

    },
    getTopics() {
      this.axios({
        method: 'get',
        url: `/topics/${this.$route.params.userID}`,
      }).then(res => {
        this.topicList = res.data.topics;
        this.topicList.forEach(t => {
            if(t.topic.is_closed != 0){
              t.status = 'closed';
            }
            else{
              t.status = 'open';
            }

        });
//        this.getTabs();
      });
    },
    showTopic(row){
      if(this.isAdmin){
        this.$router.push(`/admin/${row.topic.user_id}/posts/${row.topic.id}`);
      }
      else{
        this.$router.push(`/user/${localStorage.userID}/posts/${row.topic.id}`);
      }


    },
    addTopic() {
//      this.$refs['form'].validate(valid => {
//        if(valid){


      this.axios({
        method: 'put',
        url: `/topics/${this.$route.params.userID}/add`,
        data: this.form
      }).then(res => {
        this.getTopics();
        topicForm.style.display = 'none'
        this.$message({
          message: 'Topic Adding success!',
          type: 'success',
        });
      });


        //   return true;
        // }
        // else{
        //   return false;
        // }
      //};
    },

    deleteTopic(row) {
      //console.log(row);
      this.$confirm(
        'This will permanently delete the topic. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
// console.log(row.topic.id);
          this.axios({
            method: 'delete',
            url: `/topics/${this.$route.params.userID}`,
            params: {
              id: row.topic.id,
            },
          }).then(res => {
            if (res.data.success) {
              // this.topicList = this.topicList.filter(
              //   row => row.topic.id !== topic.id
              // );
              this.getTopics();

              //this.getTabs();
              this.$message({
                center: true,
                message: 'Delete Success',
                type: 'success',
                showClose: true,
              });
            } else {
              this.$message({
                center: true,
                message: 'Delete Fail',
                type: 'fail',
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled',
          });
        });
    },
    handleError() {
      this.$message({
        center: true,
        message: 'Upload Fail',
        type: 'error',
        showClose: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme/element-variables';
.download-button {
  color: #ffffff;
  background-color: $--color-primary;
  border: 1px solid $--color-primary;
  border-radius: 3px;
  padding: 9px 15px;
  font-size: 12px;
  display: inline-block;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/user/TopicList.vue